var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "linkedin-svgrepo-com_1_",
    "data-name": "linkedin-svgrepo-com (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 45.9,
    viewBox: "0 0 50 45.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 9.742,
    height: 31.179,
    transform: "translate(1.289 14.721)",
    fill: "#592e83"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M-265.045,283.9c-3.592,0-5.955,2.323-5.955,5.408,0,3.026,2.284,5.408,5.818,5.408h.078c3.67,0,5.955-2.4,5.935-5.408C-259.247,286.223-261.453,283.9-265.045,283.9Z",
    transform: "translate(271 -283.9)",
    fill: "#592e83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M-163.424,357.8c-5.584,0-9.078,3.046-9.723,5.193v-4.9H-184.1c.137,2.6,0,31.179,0,31.179h10.953V372.423a7.368,7.368,0,0,1,.234-2.558,5.569,5.569,0,0,1,5.271-3.827c3.807,0,5.525,2.889,5.525,7.107v16.126h11.05V371.935C-151.066,362.29-156.494,357.8-163.424,357.8Z",
    transform: "translate(201.066 -343.372)",
    fill: "#592e83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/Linkedin-logo.a6ff30359f62806e93527ed2294bf668.svg";
export { ForwardRef as ReactComponent };